<template>
    <v-dialog persistent v-model="dialog" width=50%>
        <v-card class="px-2">
            <v-container>

                <!-- header info -->
                <div class="row-pointer">
                    <v-row class="pa-4">
                        <h3>Update complaint event</h3>
                    </v-row>
                    <v-row><v-divider></v-divider></v-row>
                    <v-row dense class="pl-4 mt-6">
                        <v-col cols="4">Registered by</v-col>
                        <v-col cols="4">{{ hkrg_gebr }}</v-col>
                    </v-row>
                    <v-row dense class="pl-4 mt-0">
                        <v-col cols="4">Registration date/time</v-col>
                        <v-col cols="4">{{ $moment(hkrg_date_time).format("DD-MM-YYYY HH:mm") }}</v-col>
                    </v-row>
                    <v-row><v-divider></v-divider></v-row>
                </div>

                <v-row dense class="pl-4 mt-8">
                    <v-col cols="4">
                        <select_status :selected_eventstatus="hkrg_klst" label="Status" field="hkrg_klst" @updateData="updateData" :disabled="isClosed" />
                    </v-col>
                </v-row>

                <v-row dense class="pl-4 pr-6">
                    <v-col cols=12>
                        <v-form v-model="hkrg_valid">
                            <v-textarea v-model="hkrg_text" rows="4" required label="Complaint event text" :rules="descriptionRules">{{ hkrg_text }}</v-textarea>
                        </v-form>
                    </v-col>
                </v-row>

                <v-card fluid flat class="mt-0 pl-4 mb-4 pr-6">
                    <hokl_hosm_links :links="links" @updateData="updateData" />
                </v-card>

                <v-card-actions>
                    <v-spacer />
                    <v-btn color="primary" small :disabled="!hkrg_valid" v-on:click="saveHkrg()">Save</v-btn>
                    <v-btn color="primary" small v-on:click="dialog = false">Close</v-btn>
                </v-card-actions>

            </v-container>
        </v-card>
    </v-dialog>
</template>

<style scoped>
.row-pointer {
    cursor: default;
}
</style>

<script>

import select_status from '@/components/huov/hokl/ui/select_eventstatus.vue';
import hokl_hosm_links from '@/components/huov/ui/hokl_hosm_links.vue';

export default {

    data() {
        return {
            dialog: false,
            hkrg_encrid: null,
            hkrg_valid: false,
            hkrg_date_time: null,
            hkrg_text: '',
            hkrg_klst: '',
            hkrg_gebr: '',
            links: [],
            descriptionRules: [
                v => !!v || "A description / value is required"
            ],
            isClosed: false
        }
    },
    components: {
        select_status,
        hokl_hosm_links,
    },

    methods: {
        open(hkrg_encrid) {
            this.dialog = true;
            this.hkrg_encrid = hkrg_encrid;
            this.links = [];
            this.getSingleHkrg(hkrg_encrid);
            this.isClosed = false;
        },
        updateData(data) {
                //if (this.isClosed && data.field === 'hkrg_klst') return;
                console.log('updateData', data);
                this[data.field] = data.value;
        },
        getSingleHkrg() {
            this.$axios
                .post("ares/json/ares/huov/hokl/getSingleHkrg.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getSingleHkrg"
                    },
                    getSingleHkrg: {
                        hkrg_encrid: this.hkrg_encrid
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        console.log(res.data);
                        this.hkrg_text = res.data.getHkrg.hkrg_oms;
                        this.hkrg_klst = res.data.getHkrg.hkrg_klst;
                        this.hkrg_gebr = res.data.getHkrg.gebr_naam;
                        this.hkrg_date_time = res.data.getHkrg.hkrg_dt;
                        this.links = res.data.getHkrg.links;
                        this.isClosed = this.hkrg_klst === 'closed';
                    }
                });
        },
        saveHkrg() {
            this.$axios
                .post("ares/json/ares/huov/hokl/updHkrg.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "updHkrg"
                    },
                    updHkrg: {
                        hkrg_encrid: this.hkrg_encrid,
                        hkrg_text: this.hkrg_text,
                        hkrg_klst: this.hkrg_klst,
                        links: this.links,
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.$emit('updateData', 'refresh');
                        this.dialog = false;
                    }
                });
        }

    }
}
</script>

